/**
 * Some of these actions are tracked on backend side
 * Others are called from angular separately
 */
export enum ActionType {
  ALL = "All",
  PDF = "PDF",
  SEARCH = "SEARCH",
  EMAIL = "EMAIL",
  PRINT = "PRINT",
  DirectAccessSearch = "DirectAccessSearch",
  MDO = "MDO",
  MDO2 = "MDO2",
  PDF_FROM_EMAIL = "PDF_FROM_EMAIL",
  GENERATE_PRO_REPORT = "GENERATE_PRO_REPORT",
  EDIT_PRO_REPORT = "EDIT_PRO_REPORT",
  LOGIN = "LOGIN",
  PRO_PDF = "PRO_PDF",
  SELECT_PRO_REPORT = "SELECT_PRO_REPORT",
  ARTICLE_FROM_PDF = "ARTICLE_FROM_PDF",
  DOC_FROM_SITE = "DOC_FROM_SITE",
  POS_UPLOAD = "POS_UPLOAD",
  POS_DELETE = "POS_DELETE",
  POS_EDIT = "POS_EDIT"
}
